import React from "react";
import { Box, Typography } from "@mui/material";

import CustomModal from "../CustomModal/CustomModal";
import Button from "../CustomButtons/Button";
import modalStyle from "../../assets/jss/material-dashboard-react/components/confirmModalStyle";
import resources from "../../core/Localization/Localization.js";


export default function ConfirmationModal(props) {
    const { open, handleClose, title, text, buttonLabel, onConfirmCallback } = props;

    return (
        <CustomModal open={open} onClose={handleClose}>
            <Box sx={modalStyle.root}>
                <Box sx={modalStyle.titleContainer}>
                    <Typography sx={modalStyle.titleText}>
                        {title}
                    </Typography>
                </Box>
                <Box sx={modalStyle.bodyContainer}>
                    <Typography sx={modalStyle.bodyText}>
                        {text}
                    </Typography>
                </Box>

                <Box sx={modalStyle.footerContainer}>
                    <Button
                        type={"button"}
                        size={"sm"}
                        sx={modalStyle.button}
                        onClick={handleClose}
                    >
                        {resources.cancel}
                    </Button>
                    <Button
                        type={"button"}
                        color={"info"}
                        size={"sm"}
                        onClick={onConfirmCallback}
                    >
                        {buttonLabel}
                    </Button>
                </Box>
            </Box>
        </CustomModal>
    );
}
